import React, { Suspense } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import helper from '../../utils/helper';
import { store } from '../../utils/store';

const Navigation = (props) => {
  const [state, setState] = React.useState({
    mainMap: {},
    secondaryMap: {},
    errors: [],
    isNewDashboard: false,
  });
  const { t } = useTranslation('app');
  function activeMenu() {
    var strongNode = document.createElement('strong');
    // var strongTextNode = document.createTextNode('3');
    // strongNode.appendChild(strongTextNode);
    const navigationClass = document.getElementsByClassName('navigation')[1];
    if (navigationClass) {
      const ulTag = navigationClass.getElementsByTagName('ul')[0];
      const active = ulTag.getElementsByClassName('active')[0];
      if (active) {
        if (!active.getElementsByTagName('strong')[0]) {
          active.appendChild(strongNode);
        }
      }
    }
  }
  React.useEffect(() => {
    activeMenu();
  }, []);
  React.useEffect(() => {
    if (store.getState().general.currentProfile.useCustomDashboard) {
      activeMenu();
    }
  }, [store.getState().general.currentProfile.useCustomDashboard]);
  const departmentSettings =
    JSON.parse(localStorage.getItem('departmentSettings')) || [];
  const mainMap = departmentSettings.filter(
    (setting) => setting.parameter === 'MainMapName',
  )[0];
  const secondaryMap = departmentSettings.filter(
    (setting) => setting.parameter === 'SecondaryMapName',
  )[0];
  const isNewDashboard =
    store.getState().general.currentProfile.useCustomDashboard;
  return (
    <Suspense fallback="loading">
      <div className="navigation">
        <ul>
          <NavigationItem
            path="/"
            exact
            icon="dashboard"
            name={isNewDashboard ? 'System Dashboard' : 'Dashboard'}
          />
          {isNewDashboard ? (
            <NavigationItem
              path="/custom-dashboard"
              icon="dashboard_customize"
              name="Custom Dashboard"
            />
          ) : null}
          {helper.checkPermission('API.Users') ? (
            <NavigationItem
              path="/configure/users"
              icon="people_outline"
              name="Users"
            />
          ) : null}
          {helper.checkPermission('API.Reports') ? (
            <NavigationItem
              path="/reports"
              icon="text_snippet"
              name="Reports"
            />
          ) : null}
          {helper.checkPermission('Admin') ? (
            <NavigationItem
              path="/system-admin-dashboard"
              icon="speed"
              name="System Admin Dashboard"
            />
          ) : null}
          {(mainMap && mainMap.value) ||
          (secondaryMap && secondaryMap.value) ? (
            <strong>{t('Map List')}</strong>
          ) : null}

          {mainMap && mainMap.value ? (
            <NavigationItem path="/main-map" icon="map" name="Main Map" />
          ) : null}
          {secondaryMap && secondaryMap.value ? (
            <NavigationItem
              path="/secondary-map"
              icon="menu_book"
              name="Secondary Map"
            />
          ) : null}
        </ul>
      </div>
    </Suspense>
  );
};

const NavigationItem = ({ path, icon, name, exact = false }) => {
  const { t } = useTranslation('app');
  return (
    <li>
      <NavLink to={path} exact={exact} activeClassName="active">
        <div className="d-flex" style={{ width: '90%' }}>
          <div className="navigation-icon-container">
            <i className="md-icon">{icon}</i>
          </div>
          <span>{t(name)}</span>
        </div>
      </NavLink>
    </li>
  );
};
export default Navigation;
